'use client'

import textBodyLinkS from '@fukku/styles/texts/textBodyLinkS.module.css'
import textLegalS from '@fukku/styles/texts/textLegalS.module.css'
import { cx } from 'classix'
import { ClientLabel } from 'labels/components/ClientLabel/ClientLabel'
import genericStyles from 'labels/components/GenericStyles.module.css'
import { useCallback, useState } from 'react'
import {
	EXPAND_CHECKBOX_ID,
	EXPAND_CONTENT_ID,
	EXPAND_POLICY_TRIGGER_TESTID,
	TERMS_CONDITIONS_PAGE_PATHNAME,
} from '../../constants/privacyPolicy'
import styles from './ExpandableTextByLink.module.css'

type ExpandableTextByLinkProps = {
	readonly id?: string
	readonly className?: string
	readonly contentBeforeTrigger?: React.ReactNode
	readonly contentAfterTrigger?: React.ReactNode
	readonly contentToExpand: React.ReactNode
	readonly trigger: string
}
export function ExpandableContent({
	id,
	className = '',
	contentAfterTrigger = null,
	contentBeforeTrigger = null,
	contentToExpand,
	trigger,
}: ExpandableTextByLinkProps): React.ReactNode {
	const [expanded, setExpanded] = useState(false)
	const contentToExpandId = `${id}-${EXPAND_CONTENT_ID}`
	const placeholderValues = {
		termsAndConditions: TERMS_CONDITIONS_PAGE_PATHNAME,
	}

	const handleExpand = useCallback(() => {
		setExpanded((isExpanded) => !isExpanded)
	}, [])

	return (
		<div
			className={cx(styles.expandableContent, textLegalS.className, className)}
		>
			<p id={id} className={styles.resetContent}>
				<ClientLabel>{contentBeforeTrigger}</ClientLabel>
				<button
					type='button'
					id={EXPAND_CHECKBOX_ID}
					className={cx(
						styles.expander,
						genericStyles.anchor,
						textBodyLinkS.className
					)}
					onClick={handleExpand}
					aria-expanded={expanded}
					aria-controls={expanded ? contentToExpandId : undefined}
					data-testid={`${id}.${EXPAND_POLICY_TRIGGER_TESTID}`}
				>
					{trigger}
				</button>
				<ClientLabel
					linkProps={{
						className: styles.expander,
						small: true,
					}}
					placeholderValues={placeholderValues}
				>
					{contentAfterTrigger}
				</ClientLabel>
			</p>
			{expanded && (
				<div
					id={contentToExpandId}
					className={styles.contentToExpand}
					aria-live='polite'
				>
					{contentToExpand}
				</div>
			)}
		</div>
	)
}
